import { PaymentStatus } from "../../features/payments/models/PaymentStatus";

/** Chip colours per Payment status, shared by the balance card and the Money list. */
export const paymentStatusStyles: Record<string, string> = {
  [PaymentStatus.Received]: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300",
  [PaymentStatus.Overdue]: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300",
};

/** The chip colour for a status the map doesn't style. */
export const fallbackPaymentStatusStyle = "bg-grey-95 text-grey-40 dark:bg-primary-10 dark:text-grey-80";
